import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/VideoPoint`
//#region 数据源相关api
const GetList = `${apiUrl}`
const GetRuntimeList = `${apiUrl}/runtime`
const GetRuntimeHistory = `${apiUrl}/runtime/history`
//#endregion

export const getList = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}
export const getRuntimeList = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetRuntimeList,
        params: param
    })
}
export const getRuntimeHistory = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetRuntimeHistory,
        params: param
    })
}